import React from 'react';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Placeholder from 'react-bootstrap/Placeholder';
import HeatMapScale from '../HeatMapScale';
import i18next from '../../translations/i18n';

const formatTime = (dt) => {
  if (!dt) {
    return 'N/A';
  }
  let aux = dt;
  if (typeof dt === 'string') {
    aux = new Date(dt);
  }
  const monthNames = i18next.t('Months');
  const date = `${aux.getDate() < 10 ? `0${aux.getDate()}` : aux.getDate()}`;
  const monthName = `${JSON.parse(monthNames)[aux.getMonth()]}`;
  const fullYear = `${aux.getFullYear()}`;
  const hours = `${aux.getHours()}`;
  const minutes = `${
    aux.getMinutes() < 10 ? `0${aux.getMinutes()}` : aux.getMinutes()
  }`;
  const seconds = `${aux.getSeconds()}`;

  return `${date} ${monthName} ${fullYear}, ${hours}:${minutes}:${seconds}`;
};

const PlaceholderDiv = () => (
  <Placeholder as="div" animation="glow" className="mb-3">
    <Placeholder xs={12} />
    <Placeholder xs={12} />
  </Placeholder>
);
const HeatMapHeader = ({ lastUpdated }) => (
  <>
    <Row className="justify-content-center">
      <Col xs={12} md={8} className="p-md-0">
        {!lastUpdated && <PlaceholderDiv />}
        {lastUpdated && (
          <p className="text-center"> {i18next.t('Disclaimer')} </p>
        )}
      </Col>
    </Row>
    <Row className="justify-content-center">
      <Col xs={12} md={8}>
        <Row>
          <Col xs={12} md={6} className="order-md-2 px-5">
            {!lastUpdated && <PlaceholderDiv />}
            {lastUpdated && <HeatMapScale />}
          </Col>
          <Col xs={12} md={6} className="order-md-1">
            {!lastUpdated && <PlaceholderDiv />}
            {lastUpdated && (
              <>
                <Form.Text className="d-block text-center text-md-start">
                  {i18next.t('PercentageChange')}
                </Form.Text>
                <Form.Text className="d-block text-center text-md-start">
                  <span className="fw-bold">{i18next.t('LastUpdated')}:</span>{' '}
                  {formatTime(lastUpdated)}
                </Form.Text>
              </>
            )}
          </Col>
        </Row>
      </Col>
    </Row>
  </>
);
HeatMapHeader.defaultProps = {
  lastUpdated: '',
};
HeatMapHeader.propTypes = {
  lastUpdated: PropTypes.string,
};

export default HeatMapHeader;
